import type { FileComponentData, UpdateEntityFileSelectFunc } from './../ricos-content';
import type { EditorPluginConfig, ViewerPluginConfig } from './../ricos-types';

export const FILE_UPLOAD_TYPE = 'wix-draft-plugin-file-upload';

export interface FilePluginEditorConfig extends EditorPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  handleFileSelection?: (
    updateEntity: UpdateEntityFileSelectFunc<FileComponentData[] | FileComponentData>
  ) => void;
}
export interface FilePluginViewerConfig extends ViewerPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export interface PDFConfig {
  clientId: string;
  locale?: string;
}
